import CloseIcon from "@mui/icons-material/Close"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"

import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import CustomTextField from "../CustomTextField"
import TokenContext from "../../context/TokenContext"

import { DialogTitle, IconButton } from "@mui/material"
import { useEffect, useState } from "react"
import { licenciasVigentes, subperiodoVacacional } from "../../Redux/vacaciones"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomDateField from "../CustomDateField"
import { FormProvider, useForm } from "react-hook-form"
import moment from "moment"
import { obtenerTipoLicenciaVacaciones } from "../../Redux/autocompletados"
import { toast } from "react-toastify"
import { UserAuth } from "../../context/AuthContext"


const ModalSolicitudVacaciones = ({ open, handleClose, vacacion, onSubmit }) => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const fecha = moment();
  const fechaHoy = fecha.format('YYYY-MM-DD');

  const loadSolicitudVacacionSelector = useSelector((store) => store.vacaciones.loadSolicitudVacacion)
  const subperiodoSelector = useSelector((store) => store.vacaciones.subperiodo)

  const tipoLicenciaSelector = useSelector(store => store.autocompletados.tLicencias)

  const [fullWidth, setFullWidth] = useState(true)
  const [maxWidth, setMaxWidth] = useState("sm")
  const [opcionesSubPeriodo, setOpcionesSubPeriodo] = useState([])
  const [opcionesLicencias, setOpcionesLicencias] = useState([])

  const [tipoDeLicenciaBloqueado, setTipoDeLicenciaBloqueado] = useState(false)
  const [diasSolicitadosBloqueado, setDiasSolicitadosBloqueado] = useState(false)


  const licenciasVigentesSelector = useSelector(store => store.vacaciones.licenciasVigentes)
  const [licenciasVigentesVacaciones, setLicenciasVacaciones] = useState([])

  const { empleado } = UserAuth();

  useEffect(() => {
    if (licenciasVigentesSelector.length > 0) {
      const newArray = licenciasVigentesSelector.map(item => ({
        new_licenciaid: item.new_licenciaid,
        new_name: item.new_name,
      }));
      setLicenciasVacaciones(newArray);
    }
  }, [licenciasVigentesSelector]);


  useEffect(() => {
    if (token && vacacion) {
      dispatch(obtenerTipoLicenciaVacaciones(token))
      dispatch(subperiodoVacacional(token, vacacion.periodo_value, fechaHoy))
    }
  }, [token, vacacion])

  useEffect(() => {
    if (token && Object.keys(empleado).length > 0) {
      dispatch(licenciasVigentes(token, empleado.usuarioPortalRh, vacacion.periodo_value))
    }
  }, [token, empleado]);

  useEffect(() => {
    if (subperiodoSelector.length > 0) {
      const newArray = subperiodoSelector.map(item => ({
        value: item.new_subperiodovacacionaldefinidoid,
        label: `${item.new_name} | ${item["new_fechadesdehabilitada@OData.Community.Display.V1.FormattedValue"]} - ${item["new_fechahastahabilitada@OData.Community.Display.V1.FormattedValue"]}`,
      }));
      setOpcionesSubPeriodo(newArray);
    }
  }, [subperiodoSelector]);

  useEffect(() => {
    if (tipoLicenciaSelector.length > 0) {
      const newArray = tipoLicenciaSelector.map(item => ({
        value: item.new_tipodelicenciaid,
        label: item.new_name,
      }));
      setOpcionesLicencias(newArray);
    }
  }, [tipoLicenciaSelector]);

  const defaultValues = {
    tipoLicencia: null,
    fechaDeSolicitud: null,
    periodovacacional: null,
    diasSolicitados: null,
    // diasSolicitados: vacacion?.diasPendientes > 14 ? 14 : vacacion?.diasPendientes || vacacion?.diasPendientes > 14 && periodoVacacional.label === 'Vacaciones Fuera Período General' ? 7 : vacacion?.diasPendientes || 0,
    fechaDesde: null,
    // vacacion: vacacion.id
  }

  useEffect(() => {

    if ( vacacion && (vacacion.diasGozados>=14 || vacacion.diasSolicitados >=14) && (vacacion.diasPendientes>0) && licenciasVigentesVacaciones.length>0 ) {
      const vacaciones_fuera_de_periodo = opcionesLicencias?.find((item) => item.label == "Vacaciones Fuera Período General")
      if(vacaciones_fuera_de_periodo) {
        setValue("tipoLicencia", vacaciones_fuera_de_periodo);
        setTipoDeLicenciaBloqueado(true);
      }
    }
    else if (opcionesLicencias.length > 0 && opcionesSubPeriodo.length == 0 ) {
      const vacaciones_fuera_de_periodo = opcionesLicencias?.find((item) => item.label == "Vacaciones Fuera Período General")
      if(vacaciones_fuera_de_periodo) {
        setValue("tipoLicencia", vacaciones_fuera_de_periodo);
        setTipoDeLicenciaBloqueado(true);
      }
    }
    else if (opcionesLicencias.length > 0 && opcionesSubPeriodo.length > 0 ){
      setValue("tipoLicencia", null);
      setTipoDeLicenciaBloqueado(false);
    }

    if(vacacion && (vacacion.diasPendientes<=14 && vacacion.diasSolicitados == 0 && vacacion.diasGozados == 0)){
      setValue("diasSolicitados", vacacion.diasPendientes);
      setDiasSolicitadosBloqueado(true);
    }


  }, [vacacion, licenciasVigentesVacaciones, opcionesLicencias, opcionesSubPeriodo]);

  useEffect(() => {
    if (opcionesLicencias.length > 0 && opcionesSubPeriodo.length == 0 ) {

      const vacaciones_fuera_de_periodo = opcionesLicencias?.find((item) => item.label == "Vacaciones Fuera Período General")
      if(vacaciones_fuera_de_periodo) {
        setValue("tipoLicencia", vacaciones_fuera_de_periodo);
        setTipoDeLicenciaBloqueado(true);
      }
    }
  }, [opcionesSubPeriodo, opcionesLicencias]);

  const validacionSchema = yup.object().shape({
    fechaDeSolicitud: yup.date().nullable().typeError("Indica la fecha de Solicitud").required("Indica la fecha de Solicitud"),
    // diasSolicitados: yup.string().required("Indique los dias solicitados"),
    diasSolicitados: yup.number()
    .typeError("Cantidad de días a solicitar incorrecta")
    .test('validacionDiasSolicitados', 'Días solicitados no válidos', function (value) {
      const diasPendientes = vacacion?.diasPendientes;
      const diasGozados = vacacion?.diasGozados;
      const diasSolicitados = vacacion?.diasSolicitados;
      const diasASolicitar = parseInt(value, 10);
      const periodoVacacional = methods.watch('tipoLicencia');


      if (isNaN(diasASolicitar)) {
        return this.createError({ message: 'Por favor, ingrese un número válido.' });
      }
      
      
      if (diasASolicitar > diasPendientes) {
        return this.createError({ message: 'La cantidad de días solicitados excede los días pendientes.' });
      }

      if(diasASolicitar>14){
        var resto = diasASolicitar % 7;
        if(resto != 0)
        {
          return this.createError({ message: 'Los dias a solicitar mayores a 14 deben ser múltiplos de 7.' });
        }
      }

      if(diasPendientes>14 && diasSolicitados == 0 && diasGozados == 0 ){
        var resto = diasASolicitar % 7;
        if(resto != 0)
        {
          return this.createError({ message: 'Puede Solicitar Vacaciones de un valor múltiplo de 7.' });
        }
        if(diasASolicitar < 14 && periodoVacacional?.label === 'Vacaciones'){
            return this.createError({ message: 'Puede Solicitar Vacaciones con un Minimo de 14 días.' });
        }
      }

      if(diasPendientes>0 && (diasGozados>=7 || diasSolicitados>=7) && periodoVacacional?.label === 'Vacaciones' ) {
        var resto = diasASolicitar % 7;
        if(resto != 0)
        {
          return this.createError({ message: 'Puede Solicitar Vacaciones de un valor múltiplo de 7.' });
        }
        if(diasASolicitar < 14 && diasPendientes>=14){
          return this.createError({ message: 'Puede Solicitar Vacaciones con un Minimo de 14 días.' });
        }
      }
      if(diasPendientes>0 && (diasGozados>=14 || diasSolicitados>=14) && periodoVacacional?.label === 'Vacaciones Fuera Período General' ) {
        var resto = diasASolicitar % 7;
        if(resto != 0)
        {
          return this.createError({ message: 'Puede Solicitar Vacaciones de un valor múltiplo de 7.' });
        }
        if(diasASolicitar < 7){
          return this.createError({ message: 'No puede solicitar menos de 7 días de Vacaciones.' });
        }
      }

      return true;
    })
    .required("Indique los días solicitados"),
    fechaDesde: yup.date().nullable().typeError("Indica la fecha desde").when('tipoLicencia', {
      is: (tipoLicencia) => tipoLicencia && tipoLicencia.label === 'Vacaciones Fuera Período General',
      then: yup.date().required("Indica la fecha desde"),
      otherwise: yup.date().nullable(),
    }),
    periodovacacional: yup.object().when('tipoLicencia', {
      is: (tipoLicencia) => tipoLicencia && tipoLicencia.label === 'Vacaciones',
      then: yup.object().required('El Subperiodo es requerido'),
      otherwise: yup.object().nullable(),
    }),
    // fechaDesde: yup.date().nullable().typeError("Indica la fecha desde").required("Indica la fecha desde"),
  })

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, setValue, reset, watch } = methods

  const submitDatos = (datos) => {
    if(datos.tipoLicencia?.label == "Vacaciones" && !datos.periodovacacional){
      toast.error("No es posible agregar una licencia de tipo Vacaciones sin un Subperiodo Vacacional Definido", {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    } else {
      onSubmit(datos, vacacion.id)
    }
  }

  const handleChange = (option) => {
    setValue("tipoLicencia", option);
    setValue("fechaDeSolicitud", null);
    setValue("periodovacacional", null);
    setValue("fechaDesde", null);
  }

  const cerrarModal = () => {
    handleClose()
    reset()
  }
  console.log(vacacion)
  return (
    <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={cerrarModal}>
      <DialogTitle sx={{ m: 1, p: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesLicencias}
                req="true"
                type="text"
                name="tipoLicencia"
                lab="Tipo de Licencia"
                helperText="El tipo de licencia es requerido"
                disabled= {tipoDeLicenciaBloqueado}
                handleChange={(option) => handleChange(option)}
              />
            </Grid>
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaDeSolicitud"
                label="Fecha de solicitud:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de solicitud"
                req={true}
                className="custom-helper"
              />
            </Grid>
            {methods.watch('tipoLicencia') && methods.watch('tipoLicencia').label === 'Vacaciones' ? (
              <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect
                  options={opcionesSubPeriodo}
                  req="true"
                  type="text"
                  name="periodovacacional"
                  lab="Subperiodo Vacacional Definido"
                  helperText="El Subperiodo es requerido"
                />
              </Grid>
            ) : null}
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="number"
                name="diasSolicitados"
                label="Días Solicitados"
                rules={{ required: "Required!" }}
                disabled={diasSolicitadosBloqueado}
                // helperText="Por favor indica los días Solicitados."
                req={true}
                className="custom-helper"
              />
            </Grid>
            {methods.watch('tipoLicencia') && methods.watch('tipoLicencia').label !== 'Vacaciones' ? (
              <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
                <CustomDateField
                  name="fechaDesde"
                  label="Fecha desde:"
                  rules={{ required: "Required!" }}
                  helperText="Indica la fecha desde"
                  req={true}
                  className="custom-helper"
                />
              </Grid>
            ) : null}
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={loadSolicitudVacacionSelector === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </Grid>
        </FormProvider>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSolicitudVacaciones
